// extracted by mini-css-extract-plugin
module.exports = {"about-us":"aboutUs_about-us__bN86K","picture":"aboutUs_picture__LydOg","paragraph":"aboutUs_paragraph__clFbh"};